import {MOBILE_SAFE_AREA_INSETS} from '@ui/constants/constants'

export const getSafeAreaInsets = () => {
  try {
    return window[MOBILE_SAFE_AREA_INSETS]
  } catch (e) {
    return null
  }
}
